import { MAP_INK } from "../../components/GeoMap/mapPalette";
import { Box, Stack, Typography } from "@mui/material";
import { useIntl } from "react-intl";

import { CLIENT_PROPERTY_VALUE, RAMP, TRACKED_COLOR } from "./CompetitorMap";

/**
 * What the pins mean, under the map.
 *
 * ⚠️ Reads its swatches from `RAMP` and `TRACKED_COLOR` rather than repeating the
 * hexes. A legend that restates its colours is a legend that goes quietly wrong the
 * first time the ramp is retuned, and a wrong legend is worse than none.
 *
 * ⚠️ Present because identity is never colour alone: the tracked green sits only
 * ΔE 6.2 from the mid blue under tritanopia, so the ring on those pins and this row
 * of labels are what carry the distinction for a reader who cannot see it.
 */
const SWATCH = 12;

const RATING_STOPS = RAMP.stops.filter(
  ([value]) => value !== CLIENT_PROPERTY_VALUE
);

const MapLegend = () => {
  const intl = useIntl();

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ alignItems: "center", flexWrap: "wrap", mt: 1, rowGap: 1 }}
    >
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="caption" color="text.secondary">
          {intl.formatMessage({ id: "COMPETITOR_SELECTION_INTEREST" })}
        </Typography>
        {/* The ramp shown as its own ordered steps, smallest to largest, so the
            size channel is legible here too and not only on the map. */}
        {RATING_STOPS.map(([value, color]) => (
          <Stack
            key={value}
            direction="row"
            spacing={0.5}
            sx={{ alignItems: "center" }}
          >
            <Box
              sx={{
                width: SWATCH,
                height: SWATCH,
                borderRadius: "50%",
                backgroundColor: color,
                border: "1px solid rgba(15, 23, 42, 0.55)",
              }}
            />
            <Typography variant="caption" color="text.secondary">
              {value}
            </Typography>
          </Stack>
        ))}
      </Stack>

      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Box
          sx={{
            width: SWATCH,
            height: SWATCH,
            borderRadius: "50%",
            backgroundColor: TRACKED_COLOR,
            // The same heavier ring the map draws, so the legend shows the encoding
            // a colour-blind reader is actually relying on.
            border: "2px solid rgba(15, 23, 42, 0.75)",
          }}
        />
        <Typography variant="caption" color="text.secondary">
          {intl.formatMessage({ id: "COMPETITOR_SELECTION_TRACKED" })}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Box
          sx={{
            width: SWATCH,
            height: SWATCH,
            borderRadius: "50%",
            backgroundColor: "#fff",
            border: `3px solid ${MAP_INK}`,
          }}
        />
        <Typography variant="caption" color="text.secondary">
          {intl.formatMessage({ id: "COMPETITOR_SELECTION_YOUR_PROPERTY" })}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default MapLegend;
